import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { cachedCover, getCover } from "../utils/covers";

/** 새 디자인 곡 사진 칸: 앨범 자켓이 있으면 사진, 없으면 색 타일 + 제목 첫 글자 */
const TILES = [
  ["#20263a", "#16181e"],
  ["#2a2416", "#16181e"],
  ["#1c2a24", "#16181e"],
  ["#2a1c26", "#16181e"],
  ["#1c2430", "#16181e"],
];

const CoverTile: React.FC<{ id: number | string; title: string; size: number; radius?: number }> = ({ id, title, size, radius = 8 }) => {
  const n = Number(id) || 0;
  const [url, setUrl] = useState<string | null | undefined>(() => cachedCover(n));
  const [broken, setBroken] = useState(false);
  useEffect(() => {
    let alive = true;
    if (n && url === undefined) getCover(n).then((u) => alive && setUrl(u));
    return () => {
      alive = false;
    };
  }, [n, url]);
  if (url && !broken) {
    return <Img src={url} alt="" loading="lazy" onError={() => setBroken(true)} style={{ width: size, height: size, borderRadius: radius }} />;
  }
  const [a, b] = TILES[n % TILES.length];
  return (
    <Box style={{ width: size, height: size, borderRadius: radius, background: `linear-gradient(160deg, ${a}, ${b})`, fontSize: size * 0.42 }}>
      {(title || "").trim().charAt(0)}
    </Box>
  );
};

export default CoverTile;

// 감싸는 줄의 '& > div { flex: 1 }' 같은 규칙에 늘어나지 않게 (연주목록에서 자켓 없는 칸이 옆으로 길어지던 문제, 2026-10-05)
const Img = styled.img`
  flex: none !important;
  object-fit: cover;
  display: block;
  background: #16181e;
`;

const Box = styled.div`
  flex: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2a2e38;
  box-sizing: border-box;
  color: #ffb547;
  font-weight: 700;
  line-height: 1;
`;
